import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Observer, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BIOMETRY_PATH } from 'src/app/shared/data/biometrics.constants';
import { ISdkParams } from 'src/app/shared/interfaces/biometrics.interface';
import { AnalyticService } from 'src/app/shared/services/analytic.service';

@Injectable({
  providedIn: 'root'
})
export class BiometricsService {
  isMobile = false;
  private routeSubscription: Subscription = new Subscription();
  private renderer: Renderer2;

  sdkParams: ISdkParams = {
    BaseUrl: '',
    ProjectName: '',
    ApiKey: '',
    ProductId: '',
    UuiDevice: '',
    TokenAdo: {
      access_token: ''
    }
  };

  constructor(
    rendererFactory: RendererFactory2,
    private analyticsService: AnalyticService,
    @Inject('Window') private window: Window,
    private router: Router
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadScript(route: string): void {
    const script = this.renderer.createElement('script');
    script.src = route;
    this.renderer.appendChild(document.body, script);
  }

  loadCSS(route: string) {
    const link = this.renderer.createElement('link');
    this.renderer.setAttribute(link, 'rel', 'stylesheet');
    this.renderer.setAttribute(link, 'type', 'text/css');
    this.renderer.setAttribute(link, 'href', route);
    this.renderer.appendChild(document.head, link);
  }

  startCapture(typeCapture: number, isFrontalSide: boolean): Observable<any> {
    return new Observable((observer: Observer<any>) => {
      try {
        (this.window as any).Start(
          this.sdkParams.BaseUrl,
          this.sdkParams.ProjectName,
          this.sdkParams.ApiKey,
          this.sdkParams.ProductId,
          typeCapture,
          isFrontalSide,
          this.sdkParams.UuiDevice,
          this.sdkParams.TokenAdo.access_token,
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error: any) => {
            observer.error(error);
          }
        );
      } catch (error) {
        observer.error(error);
      }
    });
  }

  sendAnaliticError(error: any): any {
    const errorMessage = error.message ?? '';
    this.analyticsService.uTagLinkError(
      'Error servicio initCapture Biometrics ' + errorMessage,
      'error_tech_page'
    );
  }

  checkRoutesBG(): void {
    this.routeSubscription.add(
      this.router.events
        .pipe(
          filter(
            (event): event is NavigationEnd => event instanceof NavigationEnd
          )
        )
        .subscribe((e: NavigationEnd) => {
          this.checkRoute(e);
        })
    );
  }

  checkRoute(e: NavigationEnd) {
    if (e.url.includes(BIOMETRY_PATH)) {
      this.setBG();
    } else {
      this.unsetBG();
    }
  }

  unsetBG(): void {
    const element = document.querySelector('body');
    element?.classList.remove('biometrics-bg');
  }

  setBG(): void {
    const element = document.querySelector('body');
    element?.classList.add('biometrics-bg');
  }

  unsubscribeRoutes(): void {
    this.routeSubscription.unsubscribe();
  }
}
